/* EM — Reveal Header v10
   Home: bestaand reveal
   Collection: reveal via .header-sticky-wrapper
   Overig: geen reveal
*/
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var body = document.body;
    var stickyWrap = document.querySelector('.header-sticky-wrapper');
    var headerWrapper = document.getElementById('HeaderWrapper');
    var announcementBar = document.getElementById('shopify-section-announcement-bar');

    if (!body || !stickyWrap) return;

    var isHome = body.classList.contains('template-index');
    var isCollection =
      body.classList.contains('template-collection') ||
      body.classList.contains('template-list-collections');

    function clearRevealClasses() {
      body.classList.remove(
        'em-rh-enabled',
        'em-rh-home',
        'em-rh-collection',
        'em-rh-top',
        'em-rh-solid',
        'em-rh-hidden'
      );
    }

    function getAnnouncementHeight() {
      if (!announcementBar) return 0;
      return announcementBar.offsetHeight || 0;
    }

    function resetCollectionHeader() {
      clearRevealClasses();

      stickyWrap.style.position = '';
      stickyWrap.style.left = '';
      stickyWrap.style.right = '';
      stickyWrap.style.top = '';
      stickyWrap.style.zIndex = '';
      stickyWrap.style.transform = '';
      stickyWrap.style.transition = '';

      if (headerWrapper) {
        headerWrapper.style.top = '';
        headerWrapper.style.transform = '';
      }
    }
function showCollectionHeader() {
  body.classList.add('em-rh-enabled', 'em-rh-collection', 'em-rh-solid');
  body.classList.remove('em-rh-top', 'em-rh-hidden');

  stickyWrap.style.position = 'fixed';
  stickyWrap.style.left = '0';
  stickyWrap.style.right = '0';
  stickyWrap.style.top = '0';
  stickyWrap.style.zIndex = '28';
  stickyWrap.style.transform = 'translateY(0)';
  stickyWrap.style.transition = 'transform .22s ease, box-shadow .22s ease, background-color .22s ease';

  if (headerWrapper) {
    headerWrapper.style.top = '0';
    headerWrapper.style.transform = 'translateY(0)';
  }
}

function hideCollectionHeader() {
  body.classList.add('em-rh-enabled', 'em-rh-collection', 'em-rh-solid', 'em-rh-hidden');
  body.classList.remove('em-rh-top');

  stickyWrap.style.position = 'fixed';
  stickyWrap.style.left = '0';
  stickyWrap.style.right = '0';
  stickyWrap.style.top = '0';
  stickyWrap.style.zIndex = '28';
  stickyWrap.style.transform = 'translateY(-100%)';
  stickyWrap.style.transition = 'transform .22s ease, box-shadow .22s ease, background-color .22s ease';

  if (headerWrapper) {
    headerWrapper.style.top = '0';
  }
}

    if (!isHome && !isCollection) {
      resetCollectionHeader();
      return;
    }

    var lastY = window.scrollY || window.pageYOffset;
var collectionHeaderHidden = false;
var homeHeaderHidden = false;
    function handleScroll() {
      var y = window.scrollY || window.pageYOffset;

if (isHome) {
  var deltaHome = y - lastY;

  body.classList.add('em-rh-enabled', 'em-rh-home');

  if (y <= 5) {
    body.classList.add('em-rh-top');
    body.classList.remove('em-rh-solid', 'em-rh-hidden');
    homeHeaderHidden = false;
  } else {
    body.classList.remove('em-rh-top');
    body.classList.add('em-rh-solid');

    // Echt omlaag scrollen -> header verbergen
    if (deltaHome > 3 && y > 80) {
      body.classList.add('em-rh-hidden');
      homeHeaderHidden = true;
    }

    // Echt omhoog scrollen -> header tonen
    else if (deltaHome < -3) {
      body.classList.remove('em-rh-hidden');
      homeHeaderHidden = false;
    }

    // Nauwelijks beweging / uitrollen:
    // huidige state behouden
    else {
      if (homeHeaderHidden) {
        body.classList.add('em-rh-hidden');
      } else {
        body.classList.remove('em-rh-hidden');
      }
    }
  }
}

     if (isCollection) {
  var barH = getAnnouncementHeight();
  var topThreshold = Math.max(barH, 32);
  var delta = y - lastY;

  // Helemaal boven / announcement bar nog zichtbaar genoeg:
  // blijf in natuurlijke startstaat
  if (y <= topThreshold) {
    resetCollectionHeader();
    collectionHeaderHidden = false;
  }

  // Echt omlaag scrollen -> header verbergen
  else if (delta > 3) {
    hideCollectionHeader();
    collectionHeaderHidden = true;
  }

  // Echt omhoog scrollen -> header tonen
  else if (delta < -3) {
    showCollectionHeader();
    collectionHeaderHidden = false;
  }

  // Nauwelijks beweging / scroll rolt uit:
  // huidige state behouden
  else {
    if (collectionHeaderHidden) {
      hideCollectionHeader();
    } else {
      showCollectionHeader();
    }
  }
}

      lastY = y;
    }

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', function () {
      if (isCollection) {
        var y = window.scrollY || window.pageYOffset;
        if (y <= 5) resetCollectionHeader();
        else showCollectionHeader();
      }
    });
  });
})();

/* EM — desktop nav row iets lager zetten */
document.addEventListener('DOMContentLoaded', function () {
  var desktopNavRow = document.querySelector('#SiteHeader .text-center');

  function applyDesktopNavOffset() {
    if (!desktopNavRow) return;

    if (window.innerWidth >= 990) {
      desktopNavRow.style.position = 'relative';
      desktopNavRow.style.top = '8px';
    } else {
      desktopNavRow.style.position = '';
      desktopNavRow.style.top = '';
    }
  }

  applyDesktopNavOffset();
  window.addEventListener('resize', applyDesktopNavOffset);
});
/* EM — desktop collectie titel meer lucht
document.addEventListener('DOMContentLoaded', function () {
  var collectionHeaderSection = document.querySelector('.template-collection #CollectionHeaderSection');

  function applyCollectionHeaderSpacing() {
    if (!collectionHeaderSection) return;

    if (window.innerWidth >= 990) {
      collectionHeaderSection.style.paddingTop = '20px';
    } else {
      collectionHeaderSection.style.paddingTop = '';
    }
  }

  applyCollectionHeaderSpacing();
  window.addEventListener('resize', applyCollectionHeaderSpacing);
});
*/
